import constants from '@/libs/constant/constants'

export default {
  name: 'collapsible-list',
  props: {
    menuList: Array,
    clickedOn: String,
    menuItem: Object,
    fetchMenuItem: Function,
    className: String
  },
  beforeMount () {
    this.constants = constants
  },
  data () {
    return {
      data: {
        menuList: this.menuList,
        expand: false,
        constants: constants
      },
      defaultProps: {
        children: 'children',
        name: 'name',
      },
    }
  },
  methods: {
    getIconClassName () {

    },
    getValue () {
      return false
    },
    /*
    * converts count into thousand notation.
    * */
    getThousandNotation (count) {
      return count && count.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    }
  }
}
